const frequncies = {
  monthly: 4,
  annual: 6,
};

export default frequncies;
